import './favorites.js';

(function($) {
    $(document).ready(function() {
        /*
        * On click send event to GTM
        */
        $( document ).on( 'click', 'a[data-wpgu-ga-category]', function ( event ) {
            var category = $(this).data('wpgu-ga-category');
            var action = $(this).data('wpgu-ga-action');
            var label = $(this).data('wpgu-ga-label');

            window.wpguGtmTrackEvent(category, action, label);
        });
    }); // close DOM ready


    // send event data to GTM
    window.wpguGtmTrackEvent = function( category, action, label ) {
        if( !window.dataLayer ) {
            return;
        }

        var event = {
            'event': 'TrackEvent',
            'eventCategory': category,
            'eventAction': action,
            'eventLabel': label
        };

        try {
            dataLayer.push(event);
        } catch (e) {
            console.log(e);
        }
    }


})(jQuery);
